<template>
  <div
    id="data-access"
    class="builderLayout_builderPane"
    :class="{'builderPane-noToolbox': !hasObjects }"
    @mousemove="handleLeftPanelResizeOnDrag"
    @mouseup="cancelLeftPanelResizing"
    @mouseleave="cancelLeftPanelResizing"
  >
    <RouterView name="modal" />

    <ToolboxRouter
      v-if="hasObjects"
      class="main-panel builderLayout_toolbox"
      :style="{ flexBasis: leftPanelFlexBasis}"
    />

    <PanelDivider />

    <div
      id="data-access-body-wrapper"
      class="main-body builderLayout_main border-solid border-x-0 border-b-0 border-t border-subtle -ml-px"
    >
      <DataAccessRibbon
        v-if="showRibbon"
        class="builderLayout_ribbon border-0"
      />

      <BodyWrapper id="data-access-body">
        <RouterView name="body" />
      </BodyWrapper>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';
import BodyWrapper from '@/components/layout/BodyWrapper';
import ToolboxRouter from '@/components/layout/ToolboxRouter';
import PanelDivider from '@/components/layout/PanelDivider';
import DataAccessRibbon from '@/components/data-access/DataAccessRibbon';

export default {
  name: 'DataAccess',
  components: {
    BodyWrapper,
    ToolboxRouter,
    DataAccessRibbon,
    PanelDivider,
  },
  computed: {
    ...mapGetters([
      'objects',
    ]),
    ...mapGetters('ui', [
      'leftPanelFlexBasis',
      'leftPanelWidth',
    ]),
    hasObjects() {
      return this.objects.length > 0;
    },
    activeObject() {
      if (this.$route.params.objectKey) {
        return this.$store.getters.getObject(this.$route.params.objectKey);
      }

      return false;
    },
    showRibbon() {
      return this.hasObjects && this.activeObject;
    },
  },
  mounted() {
    if (!this.leftPanelWidth) {
      this.setInitialLeftPanelWidth();
    }
  },
  methods: {
    ...mapActions('ui', [
      'handleLeftPanelResizeOnDrag',
      'cancelLeftPanelResizing',
      'setInitialLeftPanelWidth',
    ]),
  },
};
</script>
